<div class="copilot-message-container" *ngIf="webInsights">
  <div class="copilot-message-header">
    <span class="copilot-message-icon">
      <img [src]="'svg/globe.svg' | assetVersion" />
    </span>
    <div class="copilot-web-insights-title">
      Web Insights
    </div>
  </div>
  <div class="copilot-message-content">
    <app-markdown [rawMarkdown]="webInsights">
    </app-markdown>
  </div>
</div>
